import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  Table,
  TableColumn,
  Progress,
  ResponseErrorPanel,
} from '@backstage/core-components';
import useAsync from 'react-use/lib/useAsync';
import { PaginatedPullRequests, PullRequest } from '@internal/backstage-plugin-bidone-backend';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';

// export const exampleUsers = {
//     values: [
//       {
//         "comment_count": 0,
//         "task_count": 0,
//         "type": "pullrequest",
//         "id": 16,
//         "title": "Feature/BDV5-30528 upgrade net8",
//         "description": "## Notes\n\n* `iTextSharp` not upgraded as we may remove it soon\n* The console app and its dependencies not upgraded as it should leave as legacy as it it\n\n## Notable changes\n\n* wip: replace EPPlus with OpenXML\n* refactor: Report implement IDisposable so it can be correctly recycled\n* wip: OpenXML vs ClosedXML\n* feat: OpenXML cell formatting\n* refactor: remove OpenXML code\n* feat: upgrade framework and dependencies.\n\n    Except iTextSharp since we are replacing it\n\n\n* chore: skip meaningless unit tests\n* chore: revert Console app AutoMapper package to match with BluePepper.\\* NuGet\n\n    Also re-run the NuGet assembly redirect on `app.config`\n\n\n* refactor: keep cell style and value consistent with current exports\n* **feat: telemetry initialiser cloud role name**\n* chore: revert solution file unnecessary changes\n\n## Dev test\n\nDeployed to DEV and the results\n\nExample output Excel sheets attached at the bottom\n\n![](https://bitbucket.org/repo/Lrn4eza/images/844833431-image.png)\nApp Insights\n\n![](https://bitbucket.org/repo/Lrn4eza/images/851939310-image.png)\nCloud Role Name \\(not yet deployed to DEV\\)\n\n![](https://bitbucket.org/repo/Lrn4eza/images/473728997-image.png)\nEmails\n\n![](https://bitbucket.org/repo/Lrn4eza/images/3704571003-image.png)\nConsole app is running and calling the extract method but crash on my example because no actual connection string supplied\n\n![](https://bitbucket.org/repo/Lrn4eza/images/290762898-image.png)\n‌",
//         "state": "OPEN",
//         "merge_commit": null,
//         "close_source_branch": true,
//         "closed_by": null,
//         "author": {
//           "display_name": "Hugh Hoang",
//           "links": {
//             "self": {
//               "href": "https://api.bitbucket.org/2.0/users/%7B45f0ae24-9a37-4884-bd18-8f4e47808b71%7D"
//             },
//             "avatar": {
//               "href": "https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/initials/HH-5.png"
//             },
//             "html": {
//               "href": "https://bitbucket.org/%7B45f0ae24-9a37-4884-bd18-8f4e47808b71%7D/"
//             }
//           },
//           "type": "user",
//           "uuid": "{45f0ae24-9a37-4884-bd18-8f4e47808b71}",
//           "account_id": "712020:f0e8d99b-f7be-4a83-b80b-380cb6853a2d",
//           "nickname": "Hugh Hoang"
//         },
//         "reason": "",
//         "created_on": "2024-06-12T23:01:40.426113+00:00",
//         "updated_on": "2024-06-12T23:15:52.758673+00:00",
//         "destination": {
//           "branch": {
//             "name": "release/2405.2"
//           },
//           "commit": {
//             "hash": "7ee01af537c0",
//             "links": {
//               "self": {
//                 "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/commit/7ee01af537c0"
//               },
//               "html": {
//                 "href": "https://bitbucket.org/bidone/bidvestdirect-customerdataextracts/commits/7ee01af537c0"
//               }
//             },
//             "type": "commit"
//           },
//           "repository": {
//             "type": "repository",
//             "full_name": "bidone/bidvestdirect-customerdataextracts",
//             "links": {
//               "self": {
//                 "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts"
//               },
//               "html": {
//                 "href": "https://bitbucket.org/bidone/bidvestdirect-customerdataextracts"
//               },
//               "avatar": {
//                 "href": "https://bytebucket.org/ravatar/%7B7d1f179d-01c0-45d3-a9fd-fa47165d1c96%7D?ts=default"
//               }
//             },
//             "name": "bidvestdirect-customerdataextracts",
//             "uuid": "{7d1f179d-01c0-45d3-a9fd-fa47165d1c96}"
//           }
//         },
//         "source": {
//           "branch": {
//             "name": "feature/BDV5-30528-upgrade-net8"
//           },
//           "commit": {
//             "hash": "6edf7423d2d1",
//             "links": {
//               "self": {
//                 "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/commit/6edf7423d2d1"
//               },
//               "html": {
//                 "href": "https://bitbucket.org/bidone/bidvestdirect-customerdataextracts/commits/6edf7423d2d1"
//               }
//             },
//             "type": "commit"
//           },
//           "repository": {
//             "type": "repository",
//             "full_name": "bidone/bidvestdirect-customerdataextracts",
//             "links": {
//               "self": {
//                 "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts"
//               },
//               "html": {
//                 "href": "https://bitbucket.org/bidone/bidvestdirect-customerdataextracts"
//               },
//               "avatar": {
//                 "href": "https://bytebucket.org/ravatar/%7B7d1f179d-01c0-45d3-a9fd-fa47165d1c96%7D?ts=default"
//               }
//             },
//             "name": "bidvestdirect-customerdataextracts",
//             "uuid": "{7d1f179d-01c0-45d3-a9fd-fa47165d1c96}"
//           }
//         },
//         "links": {
//           "self": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16"
//           },
//           "html": {
//             "href": "https://bitbucket.org/bidone/bidvestdirect-customerdataextracts/pull-requests/16"
//           },
//           "commits": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16/commits"
//           },
//           "approve": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16/approve"
//           },
//           "request-changes": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16/request-changes"
//           },
//           "diff": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/diff/bidone/bidvestdirect-customerdataextracts:6edf7423d2d1%0D7ee01af537c0?from_pullrequest_id=16&topic=true"
//           },
//           "diffstat": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/diffstat/bidone/bidvestdirect-customerdataextracts:6edf7423d2d1%0D7ee01af537c0?from_pullrequest_id=16&topic=true"
//           },
//           "comments": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16/comments"
//           },
//           "activity": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16/activity"
//           },
//           "merge": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16/merge"
//           },
//           "decline": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16/decline"
//           },
//           "statuses": {
//             "href": "https://api.bitbucket.org/2.0/repositories/bidone/bidvestdirect-customerdataextracts/pullrequests/16/statuses"
//           }
//         },
//         "summary": {
//           "type": "rendered",
//           "raw": "## Notes\n\n* `iTextSharp` not upgraded as we may remove it soon\n* The console app and its dependencies not upgraded as it should leave as legacy as it it\n\n## Notable changes\n\n* wip: replace EPPlus with OpenXML\n* refactor: Report implement IDisposable so it can be correctly recycled\n* wip: OpenXML vs ClosedXML\n* feat: OpenXML cell formatting\n* refactor: remove OpenXML code\n* feat: upgrade framework and dependencies.\n\n    Except iTextSharp since we are replacing it\n\n\n* chore: skip meaningless unit tests\n* chore: revert Console app AutoMapper package to match with BluePepper.\\* NuGet\n\n    Also re-run the NuGet assembly redirect on `app.config`\n\n\n* refactor: keep cell style and value consistent with current exports\n* **feat: telemetry initialiser cloud role name**\n* chore: revert solution file unnecessary changes\n\n## Dev test\n\nDeployed to DEV and the results\n\nExample output Excel sheets attached at the bottom\n\n![](https://bitbucket.org/repo/Lrn4eza/images/844833431-image.png)\nApp Insights\n\n![](https://bitbucket.org/repo/Lrn4eza/images/851939310-image.png)\nCloud Role Name \\(not yet deployed to DEV\\)\n\n![](https://bitbucket.org/repo/Lrn4eza/images/473728997-image.png)\nEmails\n\n![](https://bitbucket.org/repo/Lrn4eza/images/3704571003-image.png)\nConsole app is running and calling the extract method but crash on my example because no actual connection string supplied\n\n![](https://bitbucket.org/repo/Lrn4eza/images/290762898-image.png)\n‌",
//           "markup": "markdown",
//           "html": "\u003Ch2 id=\"markdown-header-notes\"\u003ENotes\u003C/h2\u003E\n\u003Cul\u003E\n\u003Cli\u003E\u003Ccode\u003EiTextSharp\u003C/code\u003E not upgraded as we may remove it soon\u003C/li\u003E\n\u003Cli\u003EThe console app and its dependencies not upgraded as it should leave as legacy as it it\u003C/li\u003E\n\u003C/ul\u003E\n\u003Ch2 id=\"markdown-header-notable-changes\"\u003ENotable changes\u003C/h2\u003E\n\u003Cul\u003E\n\u003Cli\u003Ewip: replace EPPlus with OpenXML\u003C/li\u003E\n\u003Cli\u003Erefactor: Report implement IDisposable so it can be correctly recycled\u003C/li\u003E\n\u003Cli\u003Ewip: OpenXML vs ClosedXML\u003C/li\u003E\n\u003Cli\u003Efeat: OpenXML cell formatting\u003C/li\u003E\n\u003Cli\u003Erefactor: remove OpenXML code\u003C/li\u003E\n\u003Cli\u003E\n\u003Cp\u003Efeat: upgrade framework and dependencies.\u003C/p\u003E\n\u003Cp\u003EExcept iTextSharp since we are replacing it\u003C/p\u003E\n\u003C/li\u003E\n\u003Cli\u003E\n\u003Cp\u003Echore: skip meaningless unit tests\u003C/p\u003E\n\u003C/li\u003E\n\u003Cli\u003E\n\u003Cp\u003Echore: revert Console app AutoMapper package to match with BluePepper.* NuGet\u003C/p\u003E\n\u003Cp\u003EAlso re-run the NuGet assembly redirect on \u003Ccode\u003Eapp.config\u003C/code\u003E\u003C/p\u003E\n\u003C/li\u003E\n\u003Cli\u003E\n\u003Cp\u003Erefactor: keep cell style and value consistent with current exports\u003C/p\u003E\n\u003C/li\u003E\n\u003Cli\u003E\u003Cstrong\u003Efeat: telemetry initialiser cloud role name\u003C/strong\u003E\u003C/li\u003E\n\u003Cli\u003Echore: revert solution file unnecessary changes\u003C/li\u003E\n\u003C/ul\u003E\n\u003Ch2 id=\"markdown-header-dev-test\"\u003EDev test\u003C/h2\u003E\n\u003Cp\u003EDeployed to DEV and the results\u003C/p\u003E\n\u003Cp\u003EExample output Excel sheets attached at the bottom\u003C/p\u003E\n\u003Cp\u003E\u003Cimg alt=\"\" src=\"https://bitbucket.org/repo/Lrn4eza/images/844833431-image.png\"\u003E\nApp Insights\u003C/p\u003E\n\u003Cp\u003E\u003Cimg alt=\"\" src=\"https://bitbucket.org/repo/Lrn4eza/images/851939310-image.png\"\u003E\nCloud Role Name (not yet deployed to DEV)\u003C/p\u003E\n\u003Cp\u003E\u003Cimg alt=\"\" src=\"https://bitbucket.org/repo/Lrn4eza/images/473728997-image.png\"\u003E\nEmails\u003C/p\u003E\n\u003Cp\u003E\u003Cimg alt=\"\" src=\"https://bitbucket.org/repo/Lrn4eza/images/3704571003-image.png\"\u003E\nConsole app is running and calling the extract method but crash on my example because no actual connection string supplied\u003C/p\u003E\n\u003Cp\u003E\u003Cimg alt=\"\" src=\"https://bitbucket.org/repo/Lrn4eza/images/290762898-image.png\"\u003E\n‌\u003C/p\u003E"
//         }
//       }
//     ],
//     "pagelen": 10,
//     "size": 1,
//     "page": 1
//   };

const useStyles = makeStyles({
  avatar: {
    height: 32,
    width: 32,
    borderRadius: '50%',
  },
});



type DenseTableProps = {
    pullRequests: PullRequest[];
};

export const DenseTable = ({ pullRequests }: DenseTableProps) => {
  const classes = useStyles();

  const columns: TableColumn[] = [
    { title: 'Title', field: 'title' },
    { title: 'Destination', field: 'destination' },
    { title: 'Author', field: 'author' },
    { title: 'Status', field: 'state' },
  ];

  const data = pullRequests.map(pullRequest => {
    return {
      title: pullRequest.title,
      destination: pullRequest.destination.branch.name,
      author: pullRequest.author.display_name,
      state: pullRequest.state,
    };
  });

  return (
    <Table
      title="Pull Requests"
      options={{ search: false, paging: false }}
      columns={columns}
      data={data}
    />
  );
};

export const PullRequestFetchComponent = ({ entity }: { entity: Entity }) => {
    const config = useApi(configApiRef); // Correctly use the hook at the top level
    const catalog = useApi(catalogApiRef);
    const repoSlug = entity?.metadata.annotations?.['github.com/project-slug'] ?? '';

  const { value, loading, error } = useAsync(async (): Promise<PullRequest[]> => {
    
    // Would use fetch in a real world example
    const response = await fetch(`${config.getString('backend.baseUrl')}/api/bidone/bitbucket/repos/${repoSlug}/pullrequests`);
    const pullRequests = await response.json() as PaginatedPullRequests;
    // const pullRequests: PaginatedPullRequests = data.map((item: PaginatedPullRequests) => ( item));
    return pullRequests.values;
  }, [config, catalog, repoSlug]);

  if (loading) {
    return <Progress />;
  } else if (error) {
    return <ResponseErrorPanel error={error} />;
  }

  return <DenseTable pullRequests={value || []} />;
};
